import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface CourtFloorProps {
    className?: string
}

/** Pickleball court lines in perspective, seen from behind a baseline. Stroke uses the text color. */
export const CourtFloor: FC<CourtFloorProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 1000 400'
            preserveAspectRatio='none'
            aria-hidden='true'
            className={cn('h-full w-full', className)}
            fill='none'
            stroke='currentColor'
        >
            <path d='M 330 0 L 670 0 L 1150 400 L -150 400 Z' fill='currentColor' fillOpacity='0.06' strokeWidth='1.5' vectorEffect='non-scaling-stroke' />
            <path d='M 216 95 L 784 95' strokeWidth='1.5' vectorEffect='non-scaling-stroke' />
            <path d='M 500 95 L 500 400' strokeWidth='1.5' vectorEffect='non-scaling-stroke' />
            <path d='M 300 0 L 700 0' strokeWidth='3' vectorEffect='non-scaling-stroke' />
        </svg>
    )
}
